<h2 mat-dialog-title class="gsd-title">Gestionar servicios del día</h2>

<div mat-dialog-content class="gsd-content">
  <p class="gsd-contexto">
    Bodega <strong>{{ data.codigoBodega }}</strong> · Día de picking <strong>{{ data.fechaPicking }}</strong>
  </p>

  <div class="gsd-resumen">
    <div class="gsd-stat gsd-stat--total">
      <span class="gsd-stat-valor">{{ data.totalServicios }}</span>
      <span class="gsd-stat-label">Total servicios</span>
    </div>
    <div class="gsd-stat gsd-stat--abiertos">
      <span class="gsd-stat-valor">{{ data.elegiblesCierre }}</span>
      <span class="gsd-stat-label">Abiertos</span>
    </div>
    <div class="gsd-stat gsd-stat--cerrados">
      <span class="gsd-stat-valor">{{ data.elegiblesApertura }}</span>
      <span class="gsd-stat-label">Cerrados</span>
    </div>
  </div>

  <p class="gsd-ayuda" *ngIf="data.totalServicios === 0">
    No hay servicios registrados para este día de picking.
  </p>
  <p class="gsd-ayuda" *ngIf="data.totalServicios > 0">
    Elige una acción para aplicarla a todos los servicios elegibles de una sola vez.
  </p>

  <div class="gsd-desglose" *ngIf="data.desglosePorTipo?.length">
    <div class="gsd-desglose-titulo">Por tipo de servicio</div>
    <div class="gsd-desglose-fila" *ngFor="let d of data.desglosePorTipo">
      <div class="gsd-desglose-info">
        <span class="gsd-desglose-label">{{ d.label }}</span>
        <span class="gsd-desglose-datos">
          {{ d.totalOrdenes }} órdenes · {{ d.poligonosAbiertos }} polígono(s) abierto(s) · {{ d.poligonosCerrados }} cerrado(s)
        </span>
      </div>
      <div class="gsd-desglose-acciones">
        <button mat-stroked-button class="gsd-btn-cerrar-tipo" [disabled]="d.poligonosAbiertos === 0" (click)="cerrarTipo(d.tipo)">
          <mat-icon class="gsd-btn-icon">lock</mat-icon>
          Cerrar
        </button>
        <button mat-stroked-button class="gsd-btn-abrir-tipo" [disabled]="d.poligonosCerrados === 0" (click)="abrirTipo(d.tipo)">
          <mat-icon class="gsd-btn-icon">lock_open</mat-icon>
          Abrir
        </button>
      </div>
    </div>
  </div>

  <div class="gsd-detalle-poligonos" *ngIf="data.detallePorPoligono?.length">
    <button type="button" class="gsd-toggle-detalle" (click)="toggleDetallePoligonos()">
      {{ mostrarDetallePoligonos ? 'Ocultar' : 'Ver' }} detalle por polígono ({{ data.detallePorPoligono?.length }})
      <mat-icon class="gsd-toggle-icon">{{ mostrarDetallePoligonos ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="gsd-poligonos-lista" *ngIf="mostrarDetallePoligonos">
      <div class="gsd-poligono-card" *ngFor="let p of (data.detallePorPoligono || [])">
        <div class="gsd-poligono-nombre">
          {{ p.codigo ? (p.codigo + ' - ') : '' }}{{ p.nombre || ('Polígono ' + p.id) }}
          <span class="gsd-poligono-total">{{ p.totalServicios }} servicios</span>
        </div>
        <div class="gsd-poligono-tipos" *ngIf="p.desglose.length">
          <span class="gsd-tipo-chip" [class.gsd-tipo-chip--cerrado]="t.estado === 'CERRADO'" *ngFor="let t of p.desglose">
            {{ t.label }}: <strong>{{ t.cantidadOrdenes }}</strong> ord. · {{ t.estado === 'CERRADO' ? 'Cerrado' : 'Abierto' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="gsd-actions">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button class="gsd-btn-cerrar" [disabled]="data.elegiblesCierre === 0" (click)="cerrarTodos()">
    <mat-icon class="gsd-btn-icon">lock</mat-icon>
    Cerrar los {{ data.elegiblesCierre }} abiertos
  </button>
  <button mat-raised-button class="gsd-btn-abrir" [disabled]="data.elegiblesApertura === 0" (click)="abrirTodos()">
    <mat-icon class="gsd-btn-icon">lock_open</mat-icon>
    Abrir los {{ data.elegiblesApertura }} cerrados
  </button>
</div>
